import React, { useRef, useState, useEffect } from "react";
import styled from "styled-components";
import { Dropdown } from "components/components/atoms";
import useBreakpoint from "utils/hooks/useBreakpoint";
import { searchProductTypes } from "utils/enums";

const Container = styled.div`
  ${({ isMobile }) => (isMobile ? `width: 100%;` : `width: 10.15rem;`)}
`;

const Button = styled.button`
  margin-bottom: 0.5rem;
  &:nth-last-child(1) {
    margin-bottom: 0rem;
  }
`;

const options = [
  {
    title: "Date",
    value: "date",
    displayIn: [searchProductTypes.QMI],
  },
  {
    title: "$ - $$$",
    value: "price",
    displayIn: [
      searchProductTypes.QMI,
      searchProductTypes.COMMUNITY,
      searchProductTypes.PLAN,
    ],
  },
  {
    title: "Sq. Ft.",
    value: "size",
    displayIn: [searchProductTypes.QMI, searchProductTypes.PLAN],
  },
  {
    title: "A - Z",
    value: "title",
    displayIn: [
      searchProductTypes.QMI,
      searchProductTypes.COMMUNITY,
      searchProductTypes.PLAN,
    ],
  },
  {
    title: "Availability",
    value: "availability",
    displayIn: [searchProductTypes.COMMUNITY],
  },
];

const SortDropdown = (props) => {
  const {
    productType = searchProductTypes.COMMUNITY,
    onChange = () => {},
    value,
  } = props;

  const ref = useRef();
  const [active, setActive] = useState(false);
  const breakpoint = useBreakpoint(
    typeof window !== "undefined" && window.innerWidth
  );
  const isMobile = ["sm", "xs"].includes(breakpoint);

  const filteredOptions = options.filter((o) =>
    o.displayIn.includes(productType)
  );

  const label = value ? options.find((o) => o.value === value).title : "Sort";

  const [lastSelectedOption, setLastSelectedOption] = useState("");
  const announcementRef = useRef(null);

  useEffect(() => {
    if (lastSelectedOption) {
      announcementRef.current.textContent = `${lastSelectedOption} pressed`;
    }
  }, [lastSelectedOption]);

  return (
    <Container
      isMobile={isMobile}
      onBlur={() => {
        setTimeout(() => {
          const containsFocusedElement = ref.current.contains(
            document.activeElement
          );
          if (!containsFocusedElement) {
            setActive(false);
          }
        }, 0);
      }}
      ref={ref}
    >
      <Dropdown
        label={"Sort by: " + label}
        active={active}
        setActive={setActive}
        small={!isMobile}
        lightBlue
        textLightBlue
        withSelectClick={true}
        truncateLabel={false}
      >
        <div className="px-2 flex flex-col items-center">
          {filteredOptions.map((o) => (
            <Button
              className="relative flex items-center tracking-normal text-sm whitespace-no-wrap"
              key={o.value}
              onClick={(e) => {
                onChange(o.value);
                setLastSelectedOption(o.title);
                setActive(false);
              }}
            >
              <span>{o.title}</span>
            </Button>
          ))}
        </div>
      </Dropdown>
      <div
        aria-live="polite"
        aria-atomic="true"
        ref={announcementRef}
        style={{ position: "absolute", left: "-9999px" }}
      />
    </Container>
  );
};

export default SortDropdown;
